export default Object.freeze({
  NoAuth: 0,
  ApiKeyInHeader: 1,
  ApiKeyInQueryParameters: 2,
  BearerToken: 3,
  BasicAuth: 4,
  OAuth: 5,
  AutomyOnBehalfJwt: 6,
});
